<template>
  <div v-on-click-outside="onClickOutside" class="inline-block relative">
    <a
      ref="btnDropdownRef"
      class="flex items-center justify-center text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors bg-gray-100/50 dark:bg-[#12242b]/50 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm w-[34px] h-[34px]"
      href="#"
      @click="toggleDropdown"
    >
      <i class="fa-solid fa-ellipsis-vertical"></i>
    </a>
    <div
      ref="popoverDropdownRef"
      class="bg-white/95 dark:bg-[#0d1a20]/95 backdrop-blur-xl border border-gray-300 dark:border-gray-700 shadow-2xl z-[51] float-left list-none text-left min-w-48 max-w-[300px]"
      :class="{
        hidden: !dropdownPopoverShow,
        block: dropdownPopoverShow,
        'rounded-b-lg rounded-tl-lg':
          popper?.state?.placement.includes('bottom'),
        'rounded-t-lg rounded-bl-lg': popper?.state?.placement.includes('top'),
      }"
    >
      <a
        v-if="!isPublic"
        href="#"
        class="text-sm py-2.5 px-4 font-normal block w-full whitespace-nowrap text-gray-800 dark:text-gray-200 hover:bg-blue-600 dark:hover:bg-blue-500 hover:text-white transition-colors"
        :class="{
          'rounded-tl-lg': popper?.state?.placement.includes('bottom'),
          'rounded-t-lg': popper?.state?.placement.includes('top'),
        }"
        @click="copyQuestionToNewChat"
      >
        Copy Question To New Chat
      </a>
      <a
        href="#"
        class="text-sm py-2.5 px-4 font-normal block w-full whitespace-nowrap text-gray-800 dark:text-gray-200 hover:bg-blue-600 dark:hover:bg-blue-500 hover:text-white transition-colors"
        :class="{
          'rounded-tl-lg':
            isPublic && popper?.state?.placement.includes('bottom'),
          'rounded-t-lg': isPublic && popper?.state?.placement.includes('top'),
        }"
        @click.prevent="downloadPdf"
      >
        Download as PDF
      </a>
      <a
        v-if="!isPublic"
        href="#"
        class="text-sm py-2.5 px-4 font-normal block w-full whitespace-nowrap text-gray-800 dark:text-gray-200 hover:bg-blue-600 dark:hover:bg-blue-500 hover:text-white transition-colors"
        @click="clearQuestion"
      >
        Clear and Re-Ask Question
      </a>
      <a
        v-if="!isPublic"
        href="#"
        class="text-sm py-2.5 px-4 font-normal block w-full whitespace-nowrap text-gray-800 dark:text-gray-200 hover:bg-blue-600 dark:hover:bg-blue-500 hover:text-white transition-colors"
        :class="{ 'rounded-b-lg': popper?.state?.placement.includes('bottom') }"
        @click="deleteQuestion"
      >
        Delete Question
      </a>
    </div>
  </div>
</template>

<script>
import slugify from "slugify";
import { createPopper } from "@popperjs/core";
import { vOnClickOutside } from "@vueuse/components";

export default {
  directives: {
    onClickOutside: vOnClickOutside,
  },
  props: {
    question: Object,
    collaborationSpaceHashedId: String,
    pdfBaseUrl: String,
    isPublic: Boolean,
  },
  emits: [
    "delete-question",
    "clear-question",
    "copy-question-to-new-chat",
    "download-pdf",
  ],
  data() {
    return {
      dropdownPopoverShow: false,
      popper: null,
      direction: null,
      isLoading: true,
    };
  },
  computed: {
    pdfUrl() {
      const slug = slugify(this.question.question).toLowerCase();
      return `${this.pdfBaseUrl}/question/${this.question.hashedId}/${slug}.pdf`;
    },
  },
  beforeUnmount() {
    if (this.popper) {
      this.popper.destroy();
    }
  },
  methods: {
    toggleDropdown(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.dropdownPopoverShow) {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    },
    openDropdown() {
      this.dropdownPopoverShow = true;
      this.$nextTick(() => {
        if (this.popper) {
          this.popper.destroy();
        }
        this.popper = createPopper(
          this.$refs.btnDropdownRef,
          this.$refs.popoverDropdownRef,
          {
            placement: "bottom-end",
          },
        );
      });
    },
    closeDropdown() {
      this.dropdownPopoverShow = false;
      if (this.popper) {
        this.popper.destroy();
        this.popper = null;
      }
    },
    clearQuestion() {
      this.$emit("clearQuestion");
      this.closeDropdown();
    },
    deleteQuestion() {
      this.$emit("deleteQuestion");
      this.closeDropdown();
    },
    copyQuestionToNewChat() {
      this.$emit("copyQuestionToNewChat");
      this.closeDropdown();
    },
    downloadPdf() {
      this.$emit("download-pdf", this.pdfUrl);
      this.closeDropdown();
    },
    onClickOutside() {
      if (this.dropdownPopoverShow) {
        this.closeDropdown();
      }
    },
  },
};
</script>
